import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmareDocumenteComponent } from './confirmare-documente.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [ConfirmareDocumenteComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [ConfirmareDocumenteComponent]
})
export class ConfirmareDocumenteModule { }
